import { useQuery } from "@tanstack/react-query";
import { ncKeys } from "./nc-keys";
import { Failure } from "../../odata/appu4dm/AppU4DMModel";
import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { qFailure, QFailure } from "../../odata/appu4dm/QAppU4DM";
import { odataFetch } from "../../lib/odata-fetch";

export function useFailures() {
  const { data, ...query } = useQuery({
    queryKey: ncKeys.getFailures(),
    queryFn: ({ meta }) => fetchFailures(meta!.token!),
    enabled: ({ meta }) => !!meta?.token,
  });

  return {
    failures: data?.value,
    ...query,
  };
}

type FailureResponse = Pick<Failure, "Id" | "NId" | "Name" | "Description">;

function fetchFailures(token: string) {
  const builder = createQueryBuilderV4("Failure", new QFailure())
    .filter(
      qFailure.FailureParents.any().not().and(qFailure.IsCurrent.isTrue())
    )
    .select("Id", "NId", "Name", "Description")
    .expand("FailureChildren", "Attachments");

  return odataFetch<FailureResponse>({ builder, token });
}
